import { CoreIcon } from '../core-icon';
import qrcodeCircleColorSVG from '../../assets/icons/qrcode-circle-color.svg';
import type { IconProps } from '../core-icon';

export const QrcodeCircleColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={qrcodeCircleColorSVG} {...props} />;
};
